import React, { Component, PropTypes } from "react";

class Image extends Component {
	render() {
		return(
			<img src={ this.props.src } alt={ this.props.alt } />
		)
	}
}

Image.propTypes = {
	src: PropTypes.string.isRequired,
	alt: PropTypes.string.isRequired
}

export default Image;



/** WEBPACK FOOTER **
 ** ./src/components/presentational/Image.jsx
 **/